// src/pages/mallkiosk/StallSelectScreen.js
// Core multi-vendor browse screen — grid of vendor tiles.
// FUTURE: promo banner slot is marked below.
import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

export default function StallSelectScreen({ mall, vendors, carts, totals, onSelectVendor, onOpenCart, onCancelOrder }) {
  const { t, isAr } = useLanguage();

  const vendorCount  = (vendorId) => (carts[vendorId] || []).reduce((s, i) => s + i.qty, 0);
  const vendorTotal  = (vendorId) => (carts[vendorId] || []).reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', background: 'var(--bg)', direction: isAr ? 'rtl' : 'ltr' }}>

      {/* Header */}
      <div style={{ padding: '28px 40px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <div style={{ fontSize: 38, fontWeight: 800, color: 'var(--text)' }}>{t('Choose a stall', 'اختر متجرًا')}</div>
          <div style={{ fontSize: 18, color: 'var(--text2)', marginTop: 4 }}>{mall?.name} · {vendors.length} {t('stalls', 'متاجر')}</div>
        </div>
        <button onClick={onCancelOrder} style={{
          padding: '12px 24px', borderRadius: 14, background: 'var(--bg3)', border: '1px solid var(--border)',
          color: 'var(--text3)', fontSize: 16, fontWeight: 600, cursor: 'pointer',
        }}>
          {t('✕ Start Over', '✕ البدء من جديد')}
        </button>
      </div>

      {/* FUTURE: promo banner slot */}

      {/* Vendor tiles */}
      <div style={{
        flex: 1, minHeight: 0, minWidth: 0, overflowY: 'auto', padding: '12px 40px 140px',
        display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gridAutoRows: 'min-content', gap: 24, alignContent: 'start',
      }}>
        {vendors.map(vd => {
          const count = vendorCount(vd.vendor.id);
          const total = vendorTotal(vd.vendor.id);
          const previewItems = (vd.menuItems || []).slice(0, 3);
          return (
            <div key={vd.vendor.id}
              onClick={() => onSelectVendor(vd.vendor.id)}
              style={{
                background: 'var(--bg2)', borderRadius: 24, padding: 24, cursor: 'pointer',
                border: `2px solid ${count > 0 ? 'var(--accent)' : 'var(--border)'}`,
                minHeight: 220, display: 'flex', flexDirection: 'column',
              }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 14 }}>
                {vd.vendor.logo
                  ? <img src={vd.vendor.logo} alt="" style={{ width: 64, height: 64, borderRadius: 16, objectFit: 'cover' }} />
                  : <span style={{ fontSize: 56 }}>{vd.vendor.emoji}</span>
                }
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 800, fontSize: 24, color: 'var(--text)' }}>{vd.vendor.name}</div>
                  <div style={{ fontSize: 15, color: 'var(--text2)', marginTop: 4 }}>
                    {vd.menuItems?.length || 0} {t('items', 'عناصر')}{vd.stallNo ? ` · ${t('Stall', 'متجر')} ${vd.stallNo}` : ''}
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: 8, marginTop: 'auto' }}>
                {previewItems.map(it => (
                  <span key={it.id} style={{ fontSize: 13, color: 'var(--text3)', background: 'var(--bg3)', borderRadius: 10, padding: '4px 10px' }}>
                    {it.emoji} {it.name}
                  </span>
                ))}
              </div>

              {count > 0 && (
                <div style={{ marginTop: 14, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: 15, color: 'var(--text2)' }}>{count} {t('in cart', 'في السلة')}</span>
                  <span style={{ fontSize: 20, fontWeight: 800, color: 'var(--accent)' }}>AED {total.toFixed(2)}</span>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Floating cart button */}
      {totals.totalItems > 0 && (
        <button onClick={onOpenCart} style={{
          position: 'absolute', bottom: 32, insetInlineEnd: 40,
          padding: '22px 36px', borderRadius: 80, background: 'var(--accent)', color: 'var(--button-text)',
          border: 'none', fontSize: 22, fontWeight: 800, cursor: 'pointer',
          boxShadow: '0 8px 30px rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', gap: 12,
        }}>
          🛒 {totals.totalItems} · AED {totals.grandTotal.toFixed(2)}
        </button>
      )}
    </div>
  );
}
